import { Record } from 'immutable';

const MatchingAgencyCandidateAssignRecord = Record({
  'matchingAgencyId': null,
  'matchingAgencyCandidateId': null
});

export class MatchingAgencyCandidateAssign extends MatchingAgencyCandidateAssignRecord {
  matchingAgencyId: number;
  matchingAgencyCandidateId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-agency-candidate-assign.ts